import { useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Keyword } from '../lib/types';
import atNodeDB from '../lib/database';

export default function Keywords({ dataChanged }: { dataChanged: number }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedKeywords, setSelectedKeywords] = useState<Keyword[]>([]);
  const [availableKeywords, setAvaialbleKeywords] = useState<Keyword[]>([]);
  const [showPager, setShowPager] = useState<boolean>(false);

  useEffect(() => {
    const loadKeywords = async () => {
      const [keywords, thereIsMore] = await atNodeDB.loadKeywords(searchParams.get('searchKeywords') || '', 67);
      const newAvailableKeywords = keywords.filter((keyword) => !selectedKeywords.some((selected) => selected.Id === keyword.Id));
      setAvaialbleKeywords(newAvailableKeywords);
      setShowPager(thereIsMore);
    };
    loadKeywords();
  }, [selectedKeywords, searchParams, dataChanged]);


  function removeSelectedKeyword(keyword: Keyword) {
    const newSelectedKeywords = selectedKeywords.filter(
      (keywordItem) => keywordItem !== keyword
    );
    setSelectedKeywords(newSelectedKeywords);
    setAvaialbleKeywords([keyword, ...availableKeywords]);

    const params = new URLSearchParams(searchParams);
    if (newSelectedKeywords.length > 0) {
      params.set('selectedKeywords', newSelectedKeywords.map((keywordItem) => keywordItem.Id).join(','));
    } else {
      params.delete('selectedKeywords');
    }
    setSearchParams(params);
  }

  function addSelectedKeyword(keyword: Keyword) {
    const newSlectedKeywords = [keyword, ...selectedKeywords];
    setSelectedKeywords(newSlectedKeywords);
    setAvaialbleKeywords(availableKeywords.filter((keywordItem) => keywordItem.Id !== keyword.Id));

    const params = new URLSearchParams(searchParams);
    params.set('selectedKeywords', newSlectedKeywords.map((keywordItem) => keywordItem.Id).join(','));
    setSearchParams(params);
  }

  async function searchKeywords(search: string) {
    const params = new URLSearchParams(searchParams);
    if (search) {
      params.set('searchKeywords', search);
    } else {
      params.delete('searchKeywords');
    }
    setSearchParams(params);
  }

  return (
    <div className='box'>
      <div className='search-box'>
        <input
          type="text"
          onFocus={(e) => e.target.select()}
          onChange={async (e) => searchKeywords(e.target.value)}
          placeholder="Search keywords"
          className="input-search"
        />
      </div>
      <div className="items-box">
        {selectedKeywords.length > 0 && (<div className='items-selected'>
          {selectedKeywords.map((keyword) => {
            return (
              <button
                type="button"
                key={`keyword${keyword.Id}`}
                onClick={() => removeSelectedKeyword(keyword)}
                className="btn-keyword-selected"
              >
                {keyword.Name}
              </button>
            );
          })}
        </div>)}
        <div className='items'>
          {availableKeywords.map((keyword) => {
            return (
              <button
                type="button"
                key={`availableKeyword${keyword.Id}`}
                onClick={() => addSelectedKeyword(keyword)}
                className="btn-keyword"
              >
                {keyword.Name}
              </button>
            );
          })}
        </div>
        {showPager && (
          <div className="pager">
            ...more
          </div>
        )}
      </div>
    </div>
  );
}

